import { motion } from "framer-motion";
import { Phone, Star, ArrowDown } from "lucide-react";
import { PHONE, TEL } from "./shared";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxiZWF1dGlmdWwlMjBjbGVhbiUyMGxpdmluZyUyMHJvb20lMjBkYXlsaWdodHxlbnwwfHx8fDE3ODMzNjIyODZ8MA&ixlib=rb-4.1.0&q=85"
          alt="Bright clean living room in Edmonton"
          className="w-full h-full object-cover animate-kenburns"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 to-white/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-blush/50 to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 w-full relative z-10">
        <div className="max-w-2xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 rounded-full bg-white/70 backdrop-blur border border-blush px-4 py-2 mb-8"
          >
            <div className="flex text-pink">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={14} fill="#E1AFC0" strokeWidth={0} className="animate-twinkle" style={{ animationDelay: `${i * 0.25}s` }} />
              ))}
            </div>
            <span className="text-sm text-teal-soft">Loved by families across Edmonton, AB</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[1.05] text-teal font-medium"
          >
            A perfectly clean home,
            <span className="block italic text-pink-dark">every single time.</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.25 }}
            className="mt-7 text-lg text-teal-soft leading-relaxed max-w-xl"
          >
            Gentle, detail-oriented cleaning services for homes and businesses in Edmonton.
            We bring everything, care for every corner, and leave you a spotless space.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.4 }}
            className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4"
          >
            <a
              href={TEL}
              data-testid="hero-call-button"
              className="inline-flex items-center gap-3 bg-teal text-white hover:bg-teal-dark rounded-full px-9 py-4 text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
            >
              <Phone size={20} strokeWidth={1.5} /> Call Now: {PHONE}
            </a>
            <a
              href="#services"
              className="inline-flex items-center gap-2 text-teal hover:text-pink-dark transition-colors px-4 py-4 text-lg"
            >
              Explore Services <ArrowDown size={18} strokeWidth={1.5} className="animate-floaty" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
